import Component from '../../../classes/Component';
import variables from '../../../variables';
import Headroom from 'headroom.js';

const headerId = variables.dom?.header?.getAttribute('id');

export default function () {

	return new Component({
		name: 'fixedHeader',
		requiredTargets: '#'+headerId,
		onInit() {
		    if (this.sticky && this.sticky.destroy) this.sticky.destroy()

		    this.sticky = new Headroom(this.targets[0], {
                classes : {
                    initial : 'header',
                    pinned : 'header-pinned',
                    unpinned : 'header-unpinned',
                    top : 'header-top',
                    notTop : 'header-not-top',
                    bottom : 'header-bottom',
                    notBottom : 'header-not-bottom',
                    frozen: 'header-frozen'
                },
            });

            this.sticky.init();
        },
		onDestroy() {
            if (this.sticky && this.sticky.destroy) {
                this.sticky.destroy();

                delete this.sticky;
            }
        }
	})
}
